import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { Layout, Menu, Dropdown } from "antd";
import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { getImageUrl } from "@/utils";
import LOGO_IMG from "@/assets/logo.png";

import "./layout.less";
import { getResource } from '@/services/user';
import { getCurrentUser, removeCurrentUser } from "@/utils/user.ts";
import { getOrgCopy } from '@/utils/orgCopy';
import { useRecoilState } from 'recoil';
import { resourceState } from '@/store/userStore';
import { fetchAccountLogOut } from '@/services/login';
import { storage } from '@/utils/storage';
import { filterMenuAndCollectOpenKeys, menuItems } from '@/layouts/util';

const { Sider, Content } = Layout;

const MainLayout: React.FC = () => {
    const location = useLocation();
    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const navigate = useNavigate();
    const currentUser = getCurrentUser() || {};
    const { userName, userId, companyType } = currentUser;
    const menuLabel = getOrgCopy(companyType).menu;
    const [resources, setResources] = useRecoilState(resourceState)

    const menuList = useMemo(() => {
        const source = menuItems.map((item) => (
            item.key === '/law-firm' ? { ...item, label: menuLabel } : item
        ));
        const { filteredMenu, openKeys } = filterMenuAndCollectOpenKeys(source, resources);

        setOpenKeys(openKeys);
        return filteredMenu
    }, [resources, menuLabel])


    useEffect(() => {
        getResources()
    }, [])

    const getResources = async () => {
        const { data } = await getResource({ userId })
        const list = Object.values(data)
            .flat()
            .map((i: any) => i.resourceId)
        setResources(list)
        // 存session
        storage.set('resources', list)
    }
    const handleMenuClick = ({ key }: { key: string }) => {
        navigate(key);
    };

    // 处理子菜单展开
    const handleOpenChange = (keys: string[]) => {
        setOpenKeys(keys);
    };

    const handleLogout = async () => {
        try {
            await fetchAccountLogOut({});
            removeCurrentUser();
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const renderHeader = () => {
        return (
            <div className='renderHeader'>
                <Dropdown
                    trigger={['click']}
                    placement="bottomRight"
                    overlayClassName="header-user-dropdown"
                    open={userMenuOpen}
                    onOpenChange={setUserMenuOpen}
                    menu={{
                        items: [
                            {
                                key: 'logout',
                                icon: <LogoutOutlined />,
                                label: '退出登录',
                                onClick: handleLogout,
                            },
                        ],
                    }}
                >
                    <div className={`header-user${userMenuOpen ? ' is-open' : ''}`}>
                        <img
                            className="header-user-avatar"
                            src={getImageUrl("default_tx.png")}
                            alt=""
                        />
                        <span className="header-user-name">{userName || '普通用户'}</span>
                        <DownOutlined className="header-user-arrow" />
                    </div>
                </Dropdown>
            </div>
        );
    };

    return (
        <Layout className="main-layout">
            <Sider trigger={null} collapsible className="main-sider" width={232}>
                <div className="logo">
                    <div className="container">
                        <img
                            className="logo-img"
                            src={LOGO_IMG}
                            alt=""
                        />
                        AI名片管理后台
                    </div>
                </div>
                <div className="menu-container">
                    <div className="main-menu">
                        <Menu
                            theme="light"
                            mode="inline"
                            selectedKeys={[location.pathname]}
                            openKeys={openKeys}
                            onOpenChange={handleOpenChange}
                            items={menuList}
                            onClick={handleMenuClick}
                        />
                    </div>
                </div>
            </Sider>
            <Layout className="site-layout">
                <Content className="site-content">
                    <div className="site-header">{renderHeader()}</div>
                    <div className="content-body">
                        <Outlet />
                    </div>
                </Content>
            </Layout>

        </Layout>
    );
};

export default MainLayout;
